import { Form, Typography, Button } from "antd";
import { useTranslation } from "react-i18next";
import useCreateAccount from "./useCreateAccount";

import EmailConfirmation from "../EmailConfirmation";
import CreateAccountForm from "./createAccountForm";
import classes from "./createAccount.module.css";

const { Title } = Typography;

const CreateAccount = () => {
  const { t } = useTranslation();
  const {
    form,
    onFinish,
    isEmailConfirmation,
    submitDisabled,
    createAccountLoading,
  } = useCreateAccount();

  return isEmailConfirmation ? (
    <EmailConfirmation />
  ) : (
    <>
      <Title level={2} style={{ marginBottom: 43, textAlign: "center" }}>
        {t("signupPage.title")}
      </Title>
      <Form
        form={form}
        name="createAccount"
        className={classes.root}
        onFinish={onFinish}
        layout="vertical"
      >
        <CreateAccountForm />
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            disabled={submitDisabled || createAccountLoading}
            loading={createAccountLoading}
            block
          >
            {t("signupPage.signupButton")}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default CreateAccount;
